import { Action } from '@ngrx/store';
import { type } from 'services/actions-cache/actions-cache.service';
import { UserData } from 'services/user/user.interface';

export namespace ActionCreators {
  export class GetUserData implements Action {
    static readonly type = type<'[EMPLOYER USER PROFILE] GetUserData'>('[EMPLOYER USER PROFILE] GetUserData');
    readonly type = GetUserData.type;

    constructor(public payload: { userId: string }) {}
  }

  export class GetUserDataSuccess implements Action {
    static readonly type = type<'[EMPLOYER USER PROFILE] GetUserDataSuccess'>(
      '[EMPLOYER USER PROFILE] GetUserDataSuccess',
    );
    readonly type = GetUserDataSuccess.type;

    constructor(public payload: { user: UserData }) {}
  }

  export class GetUserDataError implements Action {
    static readonly type = type<'[EMPLOYER USER PROFILE] GetUserDataError'>('[EMPLOYER USER PROFILE] GetUserDataError');
    readonly type = GetUserDataError.type;
  }
}

export type EmployerUserProfileActions =
  | ActionCreators.GetUserData
  | ActionCreators.GetUserDataSuccess
  | ActionCreators.GetUserDataError;
